<template>
	<div id="my-quote" class="wrap">
		<van-popup v-model="myshow" position="bottom" @input="toggleMyshow">
			<div class="content-wrap">
				<div class="title">他人报价</div>
				<div class="quo-list" style="margin-top: 10px;">
					<div v-for="(v, i) in quoteData" class="quo-item" style="position: relative;">
						<div class="atral" style="font-size: 36px;position: absolute;left: 12px;">
							<div style="width: 50px;text-align: center;"><van-icon name="https://b.yzcdn.cn/vant/icon-demo-1126.png"/></div>
							<div style="font-size: 12px;margin-top: -10px;width: 50px;white-space: pre-wrap;text-align: center;">{{ v.nickname }}</div>
						</div>
						<div style="width: 75vw;background-color: aliceblue;float: left;margin-left: 65px;min-height: 50px;border-radius: 12px;padding: 10px 12px;">
							<p>报价: {{ v.amount }}</p>
							<p v-if="v.quo_num">数量: {{ v.quo_num }}</p>
							<p v-if="v.dc">DC: {{ v.dc }}</p>
							<p v-if="v.submitDay">交期: {{ v.submitDay }}</p>
							<p v-if="v.timeliness">时效性: {{ v.timeliness }}</p>
							<p v-if="v.packStatus">包装状态: {{ v.packStatus }}</p>
							<p v-if="v.remark">备注: {{ v.remark }}</p>
						</div>
					</div>

				</div>
				
				
			</div>
		</van-popup>
	</div>
</template>

<script>
export default {
  components: {
  },
  props: {
		show: {
			type: Boolean,
			default: () => {
				return false;
			}
		},
		quoteData: {
			type: Array,
			default: () => {
				return [];
			}
		}
	},
  data() {
    return {
      list: [],
			myshow: this.show,
    };
  },
  watch: {},
	computed: {},
  created() {},
  mounted() {},

  methods: {
		toggleMyshow() {
			console.log(this.myshow);
			this.$emit('update:show', this.myshow);
		},
  },
};
</script>
 
<style>
	#my-quote{
		.content-wrap {
			width: 100%;
			height: 68vh;
			
		}
		
		.title {
			text-align: center;
			line-height: 36px;
			font-size: 16px;
			font-weight: 700;
			padding-top: 10px;
			box-sizing: border-box;	
			position: sticky;
			top: 0;
			z-index: 10;
			background-color: white;
		}
		
		.van-popup--bottom {
			border-top-right-radius: 8px;
			border-top-left-radius: 8px;
		}
		
		.quo-item {
			overflow: hidden;
			margin-top: 12px;
		}
		
		.quo-list {
			padding-bottom: 10px;
		}
	}
	
</style>